<main class="text-start">
  <h1 class="page-title"> {{ 'orders.title' | translate }} </h1>

  <div class="w-full bg-[#F6F6F6] rounded-lg p-3.5">
    <div class="flex justify-between items-start w-full">
      <div class="border border-[#e0e0e0] w-80 rounded-lg overflow-hidden flex">
        <span class="bg-white py-[7.5px] ps-2.5">
          <i class="bi bi-search text-sm"></i>
        </span>
        <input type="text" [(ngModel)]="searchTerm"
          class="bg-white py-[8px] px-4 w-full text-start focus:outline-none text-xs" [placeholder]="'orders.search_placeholder' | translate"
          (input)="onSearchChange($event)" />
      </div>
      <div class="text-[0.7rem] flex items-center gap-2">
        <app-filters-dropdown
          [filters]="orderFilters"
          [ngModel]="filterValues"
          (ngModelChange)="onFiltersChange($event)"
          [lang]="languageService.currentLang()"
        />
        <button app-export-excel-button></button>
      </div>
    </div>

    <div class="overflow-x-auto">
      <app-filtering-chips [options]="statusFilters" (onFilter)="getOrders($event)" />
    </div>


    <div class="w-full bg-white rounded-xl px-5 py-5 mt-3">
                  <div class="overflow-x-auto">
      <table class="generic-table">
        <thead>
          <tr>
            <th>{{ 'orders.table.uuid' | translate }}</th>
            <th>{{ 'orders.table.name' | translate }}</th>
            <th>{{ 'orders.table.status' | translate }}</th>
            <th>{{ 'orders.table.driver' | translate }}</th>
            <th>{{ 'orders.table.pickup_point' | translate }}</th>
            <th>{{ 'orders.table.placed_at' | translate }}</th>
            <th>{{ 'orders.table.details' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of ordersResponse?.results" [routerLink]="['/orders', order.order_uuid]"
            class="cursor-pointer">
            <td class="p-3 text-gray-600">#{{ order.order_uuid | slice:0:8 }}</td>
            <td>
              <div class="flex justify-start items-center gap-2">
                <div class="bg-[#FCC5F3] w-6 h-6 rounded-full">
                  <img src="dashboard/place-holders/avatar-female.png" class="w-6 h-6 rounded-full" alt="">
                </div>
                <span>{{ order.name }}</span>
              </div>
            </td>
            <td>
              <span [ngClass]="{
                                        'bg-purple-100 text-purple-700': order.status === 'preparing_order',
                                        'bg-blue-100 text-blue-700': order.status === 'placed',
                                        'bg-emerald-100 text-emerald-700': order.status === 'ready_for_pickup',
                                        'bg-yellow-100 text-yellow-700': order.status === 'out_for_delivery',
                                        'bg-green-100 text-green-700': order.status === 'delivered',
                                        'bg-red-100 text-red-700': order.status === 'cancelled' || order.status === 'rejected',
                                        'bg-rose-100 text-rose-700': order.status === 'refunded'
                                        }" class="status-chip">
                {{ ('orders.statuses.' + order.status) | translate }}
              </span>
            </td>
            <td>
              <span *ngIf="order.assigned_driver; else noDriver"
                class="inline-flex items-center gap-1.5 text-nowrap">
                <i class="bi bi-person-badge text-[#611F79]"></i>
                {{ order.assigned_driver.name }}
              </span>
              <ng-template #noDriver>
                <span class="status-chip bg-gray-100 text-gray-500">{{ 'orders.unassigned_driver' | translate }}</span>
              </ng-template>
            </td>
            <td>
              <div class="flex items-center justify-start gap-1.5">
                <div *ngFor="let vendor of order.vendors | slice:0:2"
                  class="bg-[#F4F4F4] py-1 px-1.5 rounded-md text-nowrap flex gap-2">
                  <div *ngIf="vendor.vendor.logo">
                    <img [src]="vendor.vendor.logo" class="w-4 h-4 object-cover rounded-sm">
                  </div>
                  <div class="text-[0.7rem]">
                    {{ vendor.vendor.shop_name }}
                  </div>
                </div>

                <div *ngIf="order.vendors.length > 2"
                  class="bg-[#F4F4F4] py-1 px-1.5 rounded-md text-nowrap flex gap-2">
                  <div class="text-[0.7rem]">
                    +{{ order.vendors.length - 2 }}
                  </div>
                </div>
              </div>
            </td>
            <td><span dir="ltr" class="inline-block">{{ order.placed_at | date: 'dd MMM / hh:mm a' }}</span></td>
            <td>
              <i class="bi" [ngClass]="languageService.isRtl() ? 'bi-arrow-left-circle' : 'bi-arrow-right-circle'"></i>
            </td>
          </tr>
          <tr *ngIf="ordersResponse?.count == 0" class="cursor-pointer">
            <td colspan="100%" class="text-start">{{ 'orders.empty' | translate }}</td>
          </tr>
        </tbody>
      </table>
      </div>
      <app-table-pagination *ngIf="ordersResponse" [count]="ordersResponse.count" [limit]="pagination.limit"
        (pageChange)="updatePagination($event)" />
    </div>
  </div>

</main>
